// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".database-type-icon.v-icon {\n  width: auto !important;\n}\n.database-type-icon.v-icon svg {\n  width: auto !important;\n}", ""]);
// Exports
module.exports = exports;
